import { keepPreviousData, useQuery } from '@tanstack/react-query';

import {
  partnersCampaignsApi,
  partnersCampaignsApiKeys,
  type CampaignReportParams,
} from '@/api/routes/partners/partners.campaigns.api';

/** Aggregates of one campaign for a window; idle until a campaign is chosen. */
export const usePartnersReadCampaignReport = (
  id: string | undefined,
  params: CampaignReportParams,
) => {
  return useQuery({
    queryKey: partnersCampaignsApiKeys.report(id ?? '', params),
    queryFn: () => partnersCampaignsApi.report(id as string, params).then((res) => res.data),
    enabled: Boolean(id),
    placeholderData: keepPreviousData,
  });
};
